module.exports = __webpack_public_path__ + "static/media/guanli.0d39261c.png";